<template>
  <div class="pay-page">
    <div class="recharge-container">
    
      <!-- 金额输入区域 -->
      <div class="amount-input">
        <div class="amount-field">
          <span class="currency">¥</span>
          <van-field
            v-model="rechargeAmount"
            type="number"
            placeholder="请输入金额"
            :border="false"
          />
        </div>
        <div class="balance-info">余额：¥{{ userInfo.accountBalance }}</div>
      </div>

      <!-- 快捷金额选择 -->
      <div class="amount-options">
        <van-button
          v-for="amount in rechargeOptions"
          :key="amount"
          size="small"
          type="default"
          @click="selectRechargeAmount(amount)"
        >
          ¥{{ amount }}
        </van-button>
      </div>

      <!-- 支付方式选择 -->
      <div class="payment-method">
        <van-radio-group v-model="payMethod">
          <div class="method-item">
            <van-image
              width="24"
              height="24"
              :src="require('@/assets/zhifubao.png')"
            />
            <span class="method-name">支付宝(请使用普通浏览器打开)</span>
            <van-radio name="alipay"></van-radio>
          </div>
          <br />
          <div class="method-item">
            <van-image
              width="24"
              height="24"
              :src="require('@/assets/weixin.png')"
            />
            <span class="method-name">微信(请使用微信内核浏览器打开)</span>
            <van-radio name="wechat"></van-radio>
          </div>
        </van-radio-group>
      </div>

      <!-- 充值须知 -->
      <div class="recharge-notice">
        <div
          @click="contactCustomerService()"
          style="
            text-decoration: underline;
            color: #1989fa;
            margin-bottom: 10px;
          "
        >
          <van-icon size="20" name="chat" />点击咨询客服
        </div>
        <div class="notice-title">充值须知</div>
        <div class="notice-item">1. 单笔限额1-3000元；</div>
        <div class="notice-item">2. 账号违规资金转移套现将被封号处理；</div>
        <div class="notice-item">3. 禁止未成年人充值消费。</div>
      </div>

      <!-- 充值按钮 -->
      <div class="submit-button">
        <van-button type="primary" block @click="confirmRecharge"
          >确认充值</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { showToast, showDialog } from "vant";
import request from "@/utils/request";
export default {
  name: 'PayPage',
  data() {
    return {
      rechargeAmount: '',
      accountBalance: '0.00',
      payMethod: 'alipay', // 支付方式，默认支付宝
      rechargeOptions: [100, 500, 1000, 2000],
      userInfo:{}
    }
  },
  created(){
     this.$store.dispatch("user/getUserInfo").then((res) => {
      if (res.code == 200) {
        this.userInfo = res.data;
      }
    });
  },
  methods: {
       selectRechargeAmount(amount) {
      this.rechargeAmount = amount.toString();
    },
    confirmRecharge() {
      if (!this.rechargeAmount || this.rechargeAmount <= 0) {
        this.$toast('请输入有效的充值金额');
        return;
      }

      this.$dialog.confirm({
        title: '确认充值',
        message: `确认充值 ${this.rechargeAmount} 元吗？`,
      }).then(() => {
        // 这里执行充值逻辑
        if (this.payMethod == "wechat") {
          // 微信支付逻辑
          this.$toast('跳转微信支付');
        } else {
          // 支付宝支付逻辑
          this.$toast('跳转支付宝支付');
        }
      }).catch(() => {
        // 取消操作
      });
    },
    contactCustomerService() {
      window.open("https://work.weixin.qq.com/kfid/kfc0afede0891281246");
    }
  }
}
</script>

<style scoped>
.pay-page {
  background-color: #f7f8fa;
  min-height: 100vh;
}

.recharge-container {
  padding: 16px;
}

.recharge-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.header-title {
  font-size: 18px;
  font-weight: 500;
}

.amount-input {
  background: white;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.amount-field {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #f0f0f0;
  padding-bottom: 16px;
}

.currency {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-right: 8px;
}

.balance-info {
  text-align: right;
  font-size: 14px;
  color: #666;
  margin-top: 8px;
}

.amount-options {
  display: flex;
  gap: 8px;
  margin-top: 16px;
  flex-wrap: wrap;
  margin-left: 15px;
}

.payment-method {
  background: white;
  border-radius: 8px;
  padding: 16px;
  margin: 16px 0;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.method-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.method-name {
  flex: 1;
  font-size: 14px;
}

.recharge-notice {
  background: white;
  border-radius: 8px;
  padding: 16px;
  margin: 16px 0;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.notice-title {
  font-weight: bold;
  margin-bottom: 8px;
}

.notice-item {
  font-size: 12px;
  color: #666;
  margin-bottom: 4px;
}

.submit-button {
  margin-top: 24px;
}
</style>